import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {FiPlus} from "react-icons/fi";
import {apiGetToken} from "./Actions";
import AccessTokenTable from "./AccessTokenTable";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";
import {EmptyState} from "../components/Table";

const AccessToken = () => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetToken(user.activeAreal.id, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání tokenů nastala chyba.");
            setLoading(false);
        });
    };

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám tokeny..."}/>;
        if (!loading && data) return <AccessTokenTable data={data} setData={setData}/>;
        else return <EmptyState/>;
    };

    return (
        <div>
            {user.activeAreal && (
                <div>
                    <PageHeader crumbs={[{label: "Přístupové tokeny"}]}>
                        {(user?.user?.rights?.enigooTurniketsEdit && user.activeAreal) && (
                            <TurnstileButton link="/access/token/add" text="PŘIDAT" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {_renderBody()}
                </div>
            )}
        </div>
    );
};

export default AccessToken;
